import React, { useState } from 'react';

const TASK_TYPES = [
  { id: 'call',  label: 'Anruf',    icon: <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/> },
  { id: 'email', label: 'E-Mail',   icon: <><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 7l10 7 10-7"/></> },
  { id: 'visit', label: 'Besuch',   icon: <><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></> },
  { id: 'note',  label: 'Notiz',    icon: <><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></> },
];

const TYPE_LABELS = { call: 'Anruf', email: 'E-Mail', visit: 'Besuch', note: 'Notiz' };

export default function TaskModal({ leads, onClose, onConfirm, currentUser }) {
  const [taskType, setTaskType]   = useState('call');
  const [dueDate, setDueDate]     = useState(today());
  const [dueTime, setDueTime]     = useState('09:00');
  const [note, setNote]           = useState('');
  const [confirmed, setConfirmed] = useState(false);

  function today() {
    return new Date().toISOString().slice(0, 10);
  }

  function handleConfirm() {
    if (confirmed || !leads?.length) return;
    const dt = new Date(`${dueDate}T${dueTime}:00`);
    if (Number.isNaN(dt.getTime())) return;
    const payload = {
      taskType,
      type: TYPE_LABELS[taskType] || 'To-do',
      dueDate,
      dueTime,
      dueDatetime: dt.toISOString(),
      note: note.trim(),
      assignedUserId: currentUser?.id || null,
      assignedTo: currentUser?.name || currentUser?.email || 'Ich',
    };
    setConfirmed(true);
    setTimeout(() => onConfirm(payload), 400);
  }

  return (
    <>
      {/* Backdrop */}
      <div onClick={onClose} style={{
        position: 'fixed', inset: 0, background: 'rgba(15,23,42,0.4)',
        zIndex: 60, backdropFilter: 'blur(3px)',
      }} />

      {/* Modal */}
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        background: 'var(--bg2)', borderRadius: 16,
        border: '1px solid var(--border)',
        boxShadow: '0 32px 64px rgba(15,23,42,0.18)',
        width: 480, maxWidth: 'calc(100vw - 32px)',
        zIndex: 70,
        animation: 'modalIn .18s ease-out',
      }}>
        <style>{`@keyframes modalIn { from { transform: translate(-50%,-46%); opacity:0; } to { transform: translate(-50%,-50%); opacity:1; } }`}</style>

        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '18px 20px 14px', borderBottom: '1px solid var(--border)',
        }}>
          <div>
            <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text)' }}>Aufgabe zuweisen</div>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>
              {leads.length} Lead{leads.length > 1 ? 's' : ''} ausgewählt
            </div>
          </div>
          <button onClick={onClose} style={{
            width: 28, height: 28, borderRadius: 8, background: 'var(--bg4)',
            color: 'var(--text2)', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center',
          }}>✕</button>
        </div>

        <div style={{ padding: '18px 20px', display: 'flex', flexDirection: 'column', gap: 16 }}>

          {/* Aufgaben-Typ */}
          <div>
            <Label>Aufgaben-Typ</Label>
            <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
              {TASK_TYPES.map(t => {
                const active = taskType === t.id;
                return (
                  <button key={t.id} onClick={() => setTaskType(t.id)} style={{
                    flex: 1, padding: '9px 6px', borderRadius: 'var(--radius-sm)',
                    border: `1.5px solid ${active ? 'var(--accent)' : 'var(--border)'}`,
                    background: active ? 'var(--accent-bg)' : 'var(--bg3)',
                    color: active ? 'var(--accent)' : 'var(--text2)',
                    fontSize: 12, fontWeight: active ? 600 : 400,
                    display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 5,
                    cursor: 'pointer', transition: 'all .12s',
                    boxShadow: active ? '0 0 0 3px rgba(29,190,116,0.1)' : 'none',
                  }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">{t.icon}</svg>
                    {t.label}
                  </button>
                );
              })}
            </div>
          </div>

          {/* Datum & Uhrzeit */}
          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ flex: 1 }}>
              <Label>Fällig am</Label>
              <input type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} style={inputStyle} />
            </div>
            <div style={{ width: 110 }}>
              <Label>Uhrzeit</Label>
              <input type="time" value={dueTime} onChange={e => setDueTime(e.target.value)} style={inputStyle} />
            </div>
          </div>

          {/* Notiz */}
          <div>
            <Label>Notiz <span style={{ fontWeight: 400, color: 'var(--text3)' }}>(optional)</span></Label>
            <textarea
              placeholder="z.B. Wegen Außendienst-Termin anrufen…"
              value={note}
              onChange={e => setNote(e.target.value)}
              rows={3}
              style={{ ...inputStyle, height: 'auto', padding: '8px 12px', resize: 'vertical', width: '100%' }}
            />
          </div>

          {/* Lead-Liste */}
          <div>
            <Label>Leads ({leads.length})</Label>
            <div style={{
              marginTop: 6, maxHeight: 120, overflowY: 'auto',
              border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)',
              background: 'var(--bg3)',
            }}>
              {leads.map((l, i) => (
                <div key={l.id} style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '6px 12px',
                  borderBottom: i < leads.length - 1 ? '1px solid var(--border)' : 'none',
                  fontSize: 12,
                }}>
                  <span style={{ fontWeight: 500, color: 'var(--text)' }}>{l.name}</span>
                  <span style={{ color: 'var(--text3)' }}>{l.company}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{
          padding: '14px 20px', borderTop: '1px solid var(--border)',
          display: 'flex', gap: 10, justifyContent: 'flex-end',
        }}>
          <button onClick={onClose} style={{
            height: 38, padding: '0 16px', borderRadius: 'var(--radius-sm)',
            background: 'var(--bg3)', border: '1.5px solid var(--border)',
            color: 'var(--text2)', fontSize: 13, fontWeight: 500,
          }}>Abbrechen</button>
          <button onClick={handleConfirm} disabled={confirmed || !leads?.length} style={{
            height: 38, padding: '0 20px', borderRadius: 'var(--radius-sm)',
            background: confirmed ? '#16a34a' : 'linear-gradient(135deg, #0f8a53, #159c5f)',
            border: 'none', color: 'white', fontSize: 13, fontWeight: 600,
            boxShadow: confirmed ? '0 2px 8px rgba(22,163,74,0.35)' : '0 2px 10px rgba(29,190,116,0.35)',
            display: 'flex', alignItems: 'center', gap: 6,
            transition: 'background .3s',
            cursor: confirmed ? 'default' : 'pointer',
          }}>
            {confirmed ? (
              <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M20 6L9 17l-5-5"/></svg> Gespeichert!</>
            ) : (
              <><svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg> Aufgabe erstellen</>
            )}
          </button>
        </div>
      </div>
    </>
  );
}

function Label({ children }) {
  return <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text2)', marginBottom: 4 }}>{children}</div>;
}

const inputStyle = {
  width: '100%', height: 38,
  background: 'var(--bg2)', border: '1.5px solid var(--border)',
  borderRadius: 'var(--radius-sm)', color: 'var(--text)',
  fontSize: 13, padding: '0 12px', outline: 'none',
  boxShadow: '0 1px 3px rgba(15,23,42,0.05)',
  fontFamily: 'var(--font)',
};
